import { DateFormat as AntdDateFormat } from "@empglabs/backoffice-ui-kit"
const DateFormat = props => {
  return <AntdDateFormat {...props} />
}
export default DateFormat
//